import React from 'react'
import Translation from '../../../global/Translation'

const DisplayWisenbakerIndicator = () => {
    const styles = {
        backgroundColor: '#F53000',
        color: '#FFFFFF',
        padding: '4px 8px',
        fontSize: '10px',
        fontWeight: '500',
        zIndex: 1,
        display: 'inline-block',
        lineHeight: '13px',
        maxHeight: '21px',
    }

    return (
        <div style={styles}>
            <Translation id="wisenbaker_exclusive" defaultMessage="Wisenbaker Exclusive" />
        </div>
    )
}

export default DisplayWisenbakerIndicator
